import { mapGetters } from 'vuex';

import { TemplateName } from '@/helpers/templateType';

export default {
  props: {
    disableDynamicThemes: {
      type    : Boolean,
      default : false
    }
  },
  data() {
    return {
      TemplateName
    };
  },
  computed: {
    ...mapGetters({
      getterContent : 'plataforma/newContent/getterContent',
      getterCourse  : 'plataforma/newContent/getterCourse'
    }),
    templateName() {
      const templateName = this.$route.params.id
        ? this.getterContent.context?.templateName
        : this.getterCourse.context?.templateName;
      return templateName || 'timeline';
    },
    currentTheme() {
      if (this.disableDynamicThemes) {
        return 'theme--plataforma-white';
      }
      return (
        {
          timeline  : 'theme--plataforma-white',
          streaming : 'theme--plataforma-black'
        }[this.templateName] || 'theme--plataforma-white'
      );
    },
    isDark() {
      return this.currentTheme === 'theme--plataforma-black';
    },
    dialogModalOverlayColor() {
      return {
        streaming: '#000000'
      }[this.templateName];
    },
    dialogModalOverlayOpacity() {
      return {
        streaming: 0.8
      }[this.templateName];
    }
  },
  methods: {
    getInitialTextColor() {
      return (
        {
          timeline  : '#000000',
          streaming : '#FFFFFF'
        }[this.templateName] || '#000000'
      );
    },
  }
};
